import { render, staticRenderFns } from "./DocumentSection.vue?vue&type=template&id=98f45638&scoped=true&"
import script from "./DocumentSection.vue?vue&type=script&lang=js&"
export * from "./DocumentSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSection.vue?vue&type=style&index=0&id=98f45638&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f45638",
  null
  
)

export default component.exports